export default __webpack_public_path__ + "static/media/event-detail-background.70ab1e22.png";